import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveDisplayStatus } from '@/lib/domain';
import { labelNameForCode } from '@/features/orders/lib/displayLabelCode';

export interface ClaimStatusPillProps {
  displayStatus: string | null | undefined;
  /**
   * BE `displayLabelCode`(OrderStatusLabel enum 상수, 고도몰 카탈로그 정본). 노출 시 라벨 텍스트는
   * 이 코드의 한국어 노출이름으로 렌더한다(16차 ID51). 클레임은 타입 구분 노출이름(반품접수/교환접수/
   * 반품보류/교환보류/반품회수완료/재배송중/교환완료/환불접수/환불보류/환불완료 등 14~25)을 표현하므로
   * generic CLAIM_* displayStatus 대신 displayLabelCode 를 라벨로 쓴다. 아이콘/색(badge)은
   * `displayStatus`(claim FSM) 기준 유지. 코드 미노출(레거시/미배포) 시 기존 i18n 라벨로 폴백.
   */
  displayLabelCode?: string | null | undefined;
  claimId?: string;
}

export const ClaimStatusPill = ({
  displayStatus,
  displayLabelCode,
  claimId,
}: ClaimStatusPillProps) => {
  const { t } = useTranslation('orders');
  // 아이콘/색은 displayStatus(claim) 기준(BE 가 내린 status 의 표현 메타).
  const meta = resolveDisplayStatus(
    displayStatus,
    claimId ? { orderId: claimId, entity: 'claim' } : undefined,
  );
  // 라벨 텍스트: displayLabelCode(고도몰 클레임 노출이름 정본) 우선, 부재 시 레거시 status.* i18n.
  const label = displayLabelCode
    ? labelNameForCode(displayLabelCode, t(meta.i18nKey, displayStatus ?? ''))
    : t(meta.i18nKey, displayStatus ?? '');
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={displayStatus}
      label={label}
      testId="claim-status-pill"
    />
  );
};
